import Entity from "@/services/westore/entities/entity";

export class Address extends Entity {
  static uri = "/addresses";

  static update(params = {}, id) {
    let uri = `${Address.uri}/${id}`;
    return super.put({ uri, payload: params });
  }
}
